import { toast } from 'react-hot-toast';

const RETRY_DELAY = 30000; // 30 seconds
const MAX_RETRIES = 10;

interface RetryConfig {
  onSuccess: () => void;
  onError: (error: Error) => void;
  onRetry: () => void;
}

export class ReportRetryManager {
  private retryCount = 0;
  private timeoutId: NodeJS.Timeout | null = null;

  constructor(private config: RetryConfig) {}

  handleError(error: Error): void {
    const errorMessage = error.message.toLowerCase();
    
    if (this.shouldRetry(errorMessage)) {
      this.scheduleRetry();
    } else {
      this.config.onError(error);
    }
  }

  private shouldRetry(errorMessage: string): boolean {
    if (this.retryCount >= MAX_RETRIES) {
      toast.error('Report generation is taking longer than expected. Please try again later.');
      return false;
    }

    return errorMessage.includes('being generated') || 
           errorMessage.includes('in progress');
  }

  private scheduleRetry(): void {
    this.retryCount++;
    toast.loading(`Checking report status... (Attempt ${this.retryCount}/${MAX_RETRIES})`);
    
    this.timeoutId = setTimeout(() => {
      this.config.onRetry();
    }, RETRY_DELAY);
  }

  cleanup(): void {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
  }
}